import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
//import { AppService } from '../app.service';
import { AuthService } from '../auth.service';
//import { StoredService } from '../services/stored';


@Injectable({
  providedIn: 'root',
})
export class TwofactorGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    if (this.authService.isAuthenticate.getValue() || localStorage.getItem('twofact_auth') == 'true') {
      return true;
    } else {
      this.router.navigate(['/twofactAuth']);
      return false;
    }
  }

  
}
